import { FunctionComponent, useMemo } from 'react';

import { AssemblyAvatar } from 'src/legacy/components/UI/Avatars/AssemblyAvatar';
import { CopilotAvatar } from 'src/legacy/components/UI/Avatars/CopilotAvatar';
import { UrlUtils } from 'src/utils';

export const OnboardingStepAvatar: FunctionComponent = () => {
  const isAssemblyBrandEnabled = useMemo<boolean>(
    () => UrlUtils.isAssemblyDomain(),
    [],
  );

  return isAssemblyBrandEnabled ? <AssemblyAvatar /> : <CopilotAvatar />;
};
